interface AppRoutesShape {
	readonly activity: string;
	readonly billing: string;
	readonly billingSubscription: string;
	readonly dashboard: string;
	readonly home: string;
	readonly onboardingCheckout: string;
	readonly superuser: string;
}

export const APP_ROUTES = {
	activity: "/activity",
	dashboard: "/dashboard",
	// Where the app opens: after sign-in, from a bare `/`, and on every
	// "back to home" link.
	home: "/dashboard",
	onboardingCheckout: "/onboarding-checkout",
	billing: "/billing",
	billingSubscription: "/billing?section=subscription",
	superuser: "/superuser",
} as const satisfies AppRoutesShape;
